/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneStrossle from 'base/components/standalone/Strossle';

export const DynamicStandaloneStrossle = StandaloneStrossle;
export type DynamicStandaloneStrossleProps = PropsFromComponent<typeof StandaloneStrossle>;

export const DynamicStandaloneStrossleWith = (extras: DynamicStandaloneExtras): typeof StandaloneStrossle => {
    return function DynamicStandaloneStrossle(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Strossle');
        return <StandaloneStrossle {...mergeProps({ options: { theme } }, props)} />;
    }
}